import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { TempDataService } from '../../../services/temp-data.service';
import { forkJoin } from 'rxjs';


interface Movimiento {
  estatus: string | null;
  fecha: string | null;
  monto: string;
  tipo: string;
}

@Component({
  selector: 'app-perfil02',
  templateUrl: './perfil02.component.html',
  styles: []
})
export class Perfil02Component implements OnInit {
  @ViewChild('resultados') resultados!: ElementRef;

  nombreCuenta: string = '';
  inversionInicial: number = 0;
  montoIncremento: number = 0;
  rendimientosAcumulados: number = 0;
  rendimientosTotales: number = 0;
  montoRetiros: number = 0;
  Totalizado: number = 0; 
  
  fechaInicio: string = '';
  rendimiento: string = '';

  inversionActual: string = '--';
  aumentosCapital: string = '--';
  retiros: string = '--';
  impuestos: string = '--';
  balance: string = '--';

  movimientos: Movimiento[] = [];
  amortizacion: Movimiento[] = [];
  mesAnio: string = '';
  mesesDisponibles: string[] = [];
  mesSeleccionado: string = '';
  datosSeleccionados: Movimiento[] = [];

  movimientosAgrupados: Map<string, Movimiento[]> = new Map();
  amortizacionAgrupada: Map<string, Movimiento[]> = new Map();

  constructor(
    private http: HttpClient,
    private router: Router,
    private tempDataService: TempDataService
  ) {}

  ngOnInit(): void {
    const nombreCuentaStored = localStorage.getItem('nombreCuenta');
    this.nombreCuenta = nombreCuentaStored ? nombreCuentaStored : '';
    console.log('Nombre de la cuenta cargado:', this.nombreCuenta);
  
    if (this.nombreCuenta) {
      forkJoin([
        this.http.get(`https://loginx.arcsacapital.com/inversiones_get?nombreCuenta=${this.nombreCuenta}`),
        this.http.get(`https://loginx.arcsacapital.com/rir_get?nombreCuenta=${this.nombreCuenta}`),
        this.http.get(`https://loginx.arcsacapital.com/meses_anos?nombreCuenta=${this.nombreCuenta}`)
      ]).subscribe({
        next: ([detalles, calculadora, meses]) => {
          this.cargarDetallesInversion(this.nombreCuenta);
          this.cargarDatosCalculadora(this.nombreCuenta);
          this.cargarMesesDisponibles(this.nombreCuenta);
        },
        error: err => {
          console.error('Error al cargar datos', err);
        }
      });
    } else {
      this.obtenerNombreCuenta();
    }
  }

  obtenerNombreCuenta() {
    this.tempDataService.getFormDatosPersonales().subscribe({
      next: (data) => {
        if (data && data.nombreCuenta) {
          this.nombreCuenta = data.nombreCuenta;
          localStorage.setItem('nombreCuenta', this.nombreCuenta);
          console.log('Nombre de la cuenta obtenido:', this.nombreCuenta);
          if (this.nombreCuenta) {
            this.cargarDetallesInversion(this.nombreCuenta);
            this.cargarDatosCalculadora(this.nombreCuenta);
            this.cargarMesesDisponibles(this.nombreCuenta);
          }
        } else {
          console.error('No se encontró nombreCuenta');
          this.router.navigate(['/perfil01']);
        }
      },
      error: (error) => {
        console.error('Error al obtener nombreCuenta', error);
        this.router.navigate(['/perfil01']);
      }
    });
  }

  cargarDetallesInversion(nombreCuenta: string) {
    const url = `https://loginx.arcsacapital.com/inversiones_get?nombreCuenta=${nombreCuenta}`;
    console.log('Consultando detalles de inversión con URL:', url);
    this.http.get<any[]>(url).subscribe({
      next: (response) => {
        console.log('Respuesta de detalles de inversión:', response);
        const cuenta = response.find(c => c.nombreCuenta === nombreCuenta);
        if (cuenta) {
          if (cuenta.monto_inversion) {
            this.inversionInicial = parseFloat(cuenta.monto_inversion.toString().replace(/,/g, ''));
          } else {
            console.error('El campo monto_inversion no está disponible en la respuesta para la cuenta:', nombreCuenta);
          }
          if (cuenta.fecha_inicio) {
            this.fechaInicio = cuenta.fecha_inicio;
          } else {
            console.error('El campo fecha_inicio no está disponible en la respuesta para la cuenta:', nombreCuenta);
          }
        } else {
          console.error('No se encontró la cuenta:', nombreCuenta);
        }
      },
      error: (error) => {
        console.error('Error al obtener los detalles de la inversión', error);
      }
    });
  }

  cargarDatosCalculadora(nombreCuenta: string) {
    const url = `https://loginx.arcsacapital.com/rir_get?nombreCuenta=${nombreCuenta}`;
    console.log('Consultando datos de calculadora con URL:', url);
    
    this.http.get<Movimiento[]>(url).subscribe({
      next: (response) => {
        console.log('Datos recibidos:', response);
        
        // Filtrar todos los "incrementos" con estatus "ACTIVO" y sumar sus montos
        this.montoIncremento = response
          .filter(mov => mov.tipo === "incrementos" && mov.estatus === "ACTIVO")
          .reduce((total, mov) => total + parseFloat(mov.monto), 0);

        // Filtrar todos los "retiros" con estatus "ACTIVO" y sumar sus montos
        this.montoRetiros = response
        .filter(mov => mov.tipo === "retiros" && mov.estatus === "ACTIVO")
        .reduce((total, mov) => total + parseFloat(mov.monto), 0);

        // Calcular el total con la inversión inicial
        this.Totalizado = this.inversionInicial + this.montoIncremento;
  
        console.log('Monto total de incrementos activos:', this.montoIncremento);
        console.log('Monto total de retiros activos:', this.montoRetiros);
        console.log('Totalizado:', this.Totalizado);
  
        // Procesar los movimientos
        this.movimientos = response
        .filter(mov => mov.tipo !== 'rendimientos') // excluye "rendimientos"
        .map(mov => ({
          ...mov,
          fecha: mov.fecha
        }))
        .sort((a, b) => new Date(b.fecha!).getTime() - new Date(a.fecha!).getTime())

        // Ordenar los movimientos de amortización
        this.amortizacion = response
        .filter(mov => mov.tipo !== 'incrementos' && mov.tipo !== 'retiros')
        .map(mov => ({
          ...mov,
          fecha: mov.fecha
        }))
        .sort((a, b) => new Date(a.fecha!).getTime() - new Date(b.fecha!).getTime());

        // Obtener todos los incrementos con fecha y monto
        const incrementos = this.movimientos
        .filter(mov => mov.tipo === 'incrementos')
        .map(mov => ({
          fecha: new Date(mov.fecha!),
          monto: parseFloat(mov.monto)
        }))
        .sort((a, b) => a.fecha.getTime() - b.fecha.getTime());

        // Calcular inversión acumulada mes a mes
        let inversionHistorica = this.inversionInicial;
        let historicoInversiones: { fecha: Date; inversion: number }[] = [{
        fecha: new Date(this.amortizacion[0]?.fecha || new Date()),
        inversion: inversionHistorica
        }];

        for (const inc of incrementos) {
        inversionHistorica += inc.monto;
        // Agregamos al historial desde el mes siguiente
        const siguienteMes = new Date(inc.fecha);
        siguienteMes.setMonth(siguienteMes.getMonth() + 1);
        historicoInversiones.push({
          fecha: siguienteMes,
          inversion: inversionHistorica
        });
        }

        // Sumar todos los rendimientos
        const rendimientosAjustados = response
          .filter(mov => mov.tipo === 'rendimientos')
          .map(mov => {
            const fechaMov = new Date(mov.fecha!);
            let inversionDelMes = this.inversionInicial;

            // Buscar inversión vigente en ese mes (basado en historicoInversiones)
            for (const hist of historicoInversiones) {
              if (
                hist.fecha.getFullYear() < fechaMov.getFullYear() ||
                (hist.fecha.getFullYear() === fechaMov.getFullYear() &&
                hist.fecha.getMonth() <= fechaMov.getMonth())
              ) {
                inversionDelMes = hist.inversion;
              }
            }

            const original = parseFloat(mov.monto);

            // Aplicar regla de tres si la inversión cambió
            const ajustado = inversionDelMes !== this.inversionInicial
              ? original * (inversionDelMes / this.inversionInicial)
              : original;

            return ajustado;
          });

        // Sumar todos los rendimientos ajustados
        const sumaRendimientos = rendimientosAjustados.reduce((total, monto) => total + monto, 0);

        // Guardar en variable del componente (opcional)
        this.rendimientosAcumulados = parseFloat(sumaRendimientos.toFixed(2));

        // Calcular el total con la inversión inicial
        this.rendimientosTotales = this.rendimientosAcumulados - this.montoRetiros;

        console.log('Rendimientos acumulados netos:', this.rendimientosAcumulados);
        console.log('Rendimientos acumulados netos:', this.rendimientosTotales);

        // Ajustar rendimientos mes a mes según la inversión vigente
        this.amortizacion = this.amortizacion.map(mov => {
        if (mov.tipo !== 'rendimientos') return mov;

        const fechaMov = new Date(mov.fecha!);
        let inversionDelMes = this.inversionInicial;

        // Buscar la ultima inversión vigente antes o en ese mes
        for (const hist of historicoInversiones) {
          if (
            hist.fecha.getFullYear() < fechaMov.getFullYear() ||
            (hist.fecha.getFullYear() === fechaMov.getFullYear() &&
            hist.fecha.getMonth() <= fechaMov.getMonth())
          ) {
            inversionDelMes = hist.inversion;
          }
        }

        // Si la inversión del mes es distinta de la inicial aplicar regla de tres
        if (inversionDelMes !== this.inversionInicial) {
          const original = parseFloat(mov.monto);
          const ajustado = (original * (inversionDelMes / this.inversionInicial)).toFixed(2);
          return {
            ...mov,
            monto: ajustado
          };
        }

        return mov;
        });

  
        // this.filtrarMovimientosUltimos3Meses();
        this.agrupandoMovimientosPorMes();
        this.agrupandoAmortizacionPorMes();

      },
      error: (error) => {
        console.error('Error al cargar los datos de la calculadora', error);
        this.fechaInicio = 'Error en la carga';
        this.rendimiento = 'Error en la carga';
      }
    });
  }

  cargarMesesDisponibles(nombreCuenta: string) {
    const url = `https://loginx.arcsacapital.com/meses_anos?nombreCuenta=${nombreCuenta}`;
    console.log('Consultando meses disponibles con URL:', url);
    this.http.get<{año: number, mes: number}[]>(url).subscribe({
      next: (response) => {
        this.mesesDisponibles = response.map(entry => `${this.obtenerNombreMes(entry.mes)} ${entry.año}`);
        console.log('Meses disponibles cargados:', this.mesesDisponibles);
      },
      error: (error) => {
        console.error('Error al cargar los meses disponibles', error);
      }
    });
  }

  ajustarFecha(fecha: string): string {
    const date = new Date(fecha);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  obtenerNombreMes(numeroMes: number): string {
    const meses = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    return meses[numeroMes - 1];
  }

  consultarPeriodo() {
    if (this.mesSeleccionado) {
      const [mesNombre, año] = this.mesSeleccionado.split(' ');
      const mes = this.getNumeroMes(mesNombre);
      const url = `https://loginx.arcsacapital.com/calculadora?nombreCuenta=${this.nombreCuenta}&mes=${mes}&año=${año}`;
      console.log('Consultando datos del periodo con URL:', url);
      this.http.get<Movimiento[]>(url).subscribe({
        next: (movimientos) => {
          this.datosSeleccionados = movimientos.map(mov => ({
            ...mov,
            fecha: mov.fecha
          }));
          console.log('Datos seleccionados para el periodo:', this.datosSeleccionados);
          this.scrollToResultados();
        },
        error: (error) => {
          console.error('Error al consultar los datos del periodo', error);
        }
      });
    } else {
      console.error('No se ha seleccionado un periodo');
    }
  }

  consultarOtroPeriodo() {
    if (this.mesSeleccionado) {
      const [mesNombre, año] = this.mesSeleccionado.split(' ');
      const mes = this.getNumeroMes(mesNombre);
      const url = `https://loginx.arcsacapital.com/calculadora?nombreCuenta=${this.nombreCuenta}&mes=${mes}&año=${año}`;
      console.log('Consultando datos del periodo con URL:', url);
      this.http.get<Movimiento[]>(url).subscribe({
        next: (movimientos) => {
          this.datosSeleccionados = movimientos.map(mov => ({
            ...mov,
            fecha: this.ajustarFecha(mov.fecha!)
          }));
          console.log('Datos seleccionados para el periodo:', this.datosSeleccionados);
          this.scrollToResultados();
        },
        error: (error) => {
          console.error('Error al consultar los datos del periodo', error);
        }
      });
    } else {
      console.error('No se ha seleccionado un periodo');
    }
  }

  getNumeroMes(nombreMes: string): number {
    const meses = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    return meses.indexOf(nombreMes) + 1;
  }

  scrollToResultados() {
    setTimeout(() => {
      if (this.resultados) {
        this.resultados.nativeElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 0);
  }

  filtrarMovimientosUltimos3Meses() {
    const hoy = new Date();
    const hace3Meses = new Date(hoy.getFullYear(), hoy.getMonth() - 3, 1); // Inicio del mes hace 3 meses
    this.movimientos = this.movimientos.filter(mov => {
      const fechaMovimiento = new Date(mov.fecha!);
      return fechaMovimiento >= hace3Meses && fechaMovimiento <= hoy;
    });
  }

  agrupandoMovimientosPorMes() {
    const map = this.movimientos.reduce((acc, mov) => {
      const mesAnio = this.obtenerMesAnio(mov.fecha!);
      if (!acc.has(mesAnio)) {
        acc.set(mesAnio, []);
      }
      acc.get(mesAnio)!.push(mov);
      return acc;
    }, new Map<string, Movimiento[]>());
  
    // Ordenar las claves de la fecha
    this.movimientosAgrupados = new Map(
      Array.from(map).sort((a, b) => new Date(b[0]).getTime() - new Date(a[0]).getTime())
    );
  }

  // Manejo de amortizacion por mes
  agrupandoAmortizacionPorMes() {
    const map = this.amortizacion.reduce((acc, mov) => {
      const mesAnio = this.obtenerMesAnio(mov.fecha!);
      if (!acc.has(mesAnio)) {
        acc.set(mesAnio, []);
      }
      acc.get(mesAnio)!.push(mov);
      return acc;
    }, new Map<string, Movimiento[]>());
  
    // Ordenar las claves
    this.amortizacionAgrupada = new Map(
      Array.from(map).sort((a, b) => new Date(b[0]).getTime() - new Date(a[0]).getTime())
    );
  }  

  // Nueva Funcion de obtencion de mes por año
  sortByMesAnio = (a: { key: string }, b: { key: string }): number => {
    const meses: { [nombre: string]: number } = {
      enero: 0, febrero: 1, marzo: 2, abril: 3,
      mayo: 4, junio: 5, julio: 6, agosto: 7,
      septiembre: 8, octubre: 9, noviembre: 10, diciembre: 11
    };
  
    const parse = (mesAnio: string): Date => {
      const [mesNombre, anioStr] = mesAnio.toLowerCase().split(' ');
      const mes = meses[mesNombre];
      const anio = parseInt(anioStr, 10);
      return new Date(anio, mes);
    };
  
    return parse(a.key).getTime() - parse(b.key).getTime();
  };

  // Correcion Orden mes por mes no por a-z
  obtenerMesAnio(fecha: string): string {
    const date = new Date(fecha);
    const nombreMes = date.toLocaleString('es-ES', { month: 'long' });
    const mesCapitalizado = nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1);
    const year = date.getFullYear();
    return `${mesCapitalizado} ${year}`;
  }
}